import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    cancel: 'Cancel',
    ok: 'Got it',
    close: 'Close',
  },
  ru: {
    cancel: 'Отмена',
    ok: 'Понятно',
    close: 'Закрыть',
  },
  uz: {
    cancel: 'Bekor qilish',
    ok: 'Tushunarli',
    close: 'Yopish',
  },
  fa: {
    cancel: 'بی‌خیال',
    ok: 'باشه',
    close: 'بستن',
  },
  pt: {
    cancel: 'Cancelar',
    ok: 'Entendi',
    close: 'Fechar',
  },
  tr: {
    cancel: 'İptal',
    ok: 'Anladım',
    close: 'Kapat',
  },
  uk: {
    cancel: 'Скасувати',
    ok: 'Зрозуміло',
    close: 'Закрити',
  },
  de: {
    cancel: 'Abbrechen',
    ok: 'Verstanden',
    close: 'Schließen',
  },
  es: {
    cancel: 'Cancelar',
    ok: 'Entendido',
    close: 'Cerrar',
  },
  pl: {
    cancel: 'Anuluj',
    ok: 'Rozumiem',
    close: 'Zamknij',
  },
});
